// extracted by mini-css-extract-plugin
export var equalColumn = "_h8-0";